import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceToken: "",
};

export const FCMSlice = createSlice({
  name: "fcm",
  initialState,
  reducers: {
    fcmHandler: (state, action) => {
      state.deviceToken = action.payload;
    },
  },
});

export const { fcmHandler } = FCMSlice.actions;
export default FCMSlice.reducer;
